import cn from 'classnames'

import css from './text.module.scss'

type TextStyle = 'italic' | 'normal'
type TextWeight = 'normal' | 'bold' | 'lite'
type TextAlign = 'right' | 'left' | 'center'

type TextProps = {
  weight?: TextWeight
  fontStyle?: TextStyle
  align?: TextAlign
  className?: string
  children?: React.ReactNode
}

const Text = ({ children, className = '', fontStyle = 'normal', weight = 'normal', align = 'left' }: TextProps) => {
  const getStyles = () =>
    cn(`${css.container} ${className}`, {
      [css.bold]: weight === 'bold',
      [css.lite]: weight === 'lite',
      [css.alignCenter]: align === 'center',
      [css.alignRight]: align === 'right',
      [css.italic]: fontStyle === 'italic',
    })

  return <p className={getStyles()}>{children}</p>
}

export default Text
